import * as styles from './index.module.scss';

import { useContext } from 'react';

import { formatPhoneNumber } from '@/helpers/helpers';
import { SiteContext } from '@/contexts/site-context';

export const useTrackedPhoneNumber = () => {
  const [site] = useContext(SiteContext);

  return { phoneNumber: site.phone_number };
};

export const TrackedPhoneNumber = ({ className }: { className?: string }) => {
  const { phoneNumber } = useTrackedPhoneNumber();

  if (!phoneNumber) return <span className={styles['placeholder']}></span>;

  return (
    <a className={`${styles['phone']} ${className || ''}`} href={`tel:${phoneNumber}`}>
      {formatPhoneNumber(phoneNumber)}
    </a>
  );
};
